import React from 'react'
import PropTypes from 'prop-types'
import { isNilEmpty } from 'Utils'
import { _PopularSearchContainer, _PopularSearchItem, _Title } from './styles'

const PopularAreasSearch = ({
  onSuggestionSelect,
  showPopSearches,
  popularAreas,
}) => {
  const onPopularSearchClick = (e, search) => {
    e.preventDefault()
    e.stopPropagation()
    onSuggestionSelect(search, true)
  }
  return (
    <_PopularSearchContainer>
      {
        showPopSearches && !isNilEmpty(popularAreas) ?
          <>
            <_Title title={'Popular Searches'} />
            <ul>
              {
                popularAreas.map((item) => (
                  <div
                    key={'popularSearches' + item.url}
                    onClick={(e) => onPopularSearchClick(e, item)}
                  >
                    <_PopularSearchItem
                      key={item.title}
                      item={item}
                    />
                  </div>
                ))
              }
            </ul>
          </>
          : ''
      }
    </_PopularSearchContainer>
  )
}

PopularAreasSearch.propTypes = {
  popularAreas: PropTypes.arrayOf(PropTypes.shape({})),
  onSuggestionSelect: PropTypes.func,
  showPopSearches: PropTypes.bool,
}

export default PopularAreasSearch
